import styled from 'styled-components'

export const Container = styled.div`
    border-radius: 0px 8px 8px 0px;
    border-left: ${({ theme }) => `3px solid ${theme.colors.blue}`};
    padding: 8px 16px 8px 8px;
    display: flex;
    flex-direction: column;
    width: max-content;
    margin-bottom: 1rem;
    background-color: ${({ theme }) => theme.colors.white};
`
